export const TIPOS_EVALUACION_ANUAL = {
  EVACOM: 8,
  EVACOM_MANDOS: 9,
}
